import { Col } from "react-bootstrap";

const FormField = ({
  label,
  name,
  formik,
  type = "text",
  colSize,
  placeholder,
  isTextarea,
  value,
  disabled,
  icon,
  isRequired = false,
  isUpperCase = false,
  isLowerCase = false,
  ...props
}) => {
  const showError = formik?.touched?.[name] && formik?.errors?.[name];
  const inputValue = formik ? formik.values[name] : value;

  const handleChange = (e) => {
    let val = e.target.value;

    if (isUpperCase) {
      val = val.toUpperCase();
    }

    if (isLowerCase) {
      val = val.toLowerCase();
    }
    if (isUpperCase && isLowerCase) return;
    
    if (formik) {
      formik.setFieldValue(name, val);
    } else if (props.onChange) {
      props.onChange(e);
    }
  };

  return (
    <Col lg={colSize}>
      <div className="mb-3">
        <label htmlFor={name} className="form-label label">
          {label}{" "}
          {isRequired && <span style={{ color: "red" }}>*</span>}
        </label>

        <div className="position-relative">
          {isTextarea ? (
            <textarea
              id={name}
              name={name}
              className="form-control login-input"
              placeholder={placeholder}
              onChange={handleChange}
              onBlur={formik?.handleBlur}
              value={inputValue}
              disabled={disabled}
              style={props.style}
              {...props}
            />
          ) : (
            <input
              type={type}
              id={name}
              name={name}
              className="form-control pe-5"
              placeholder={placeholder}
              onChange={handleChange}
              onBlur={formik?.handleBlur}
              value={inputValue}
              disabled={disabled}
              {...props}
            />
          )}

          {icon && (
            <span
              className="position-absolute"
              style={{
                right: "10px",
                top: "50%",
                transform: "translateY(-50%)",
                cursor: "pointer",
                color: "#aaa"
              }}
            >
              {icon}
            </span>
          )}
        </div>

        {showError && <div className="text-danger">{formik.errors[name]}</div>}
      </div>
    </Col>
  );
};

export default FormField;
